<template>
 <div>
  <div class="home" >
    <div class="content">
      <div class="user-info">
        <div style="display:flex;">
          <div style="width: 50%">
            <van-image :src="require('assets/imgs/home_more.png')" style="margin-left: 5px" @click="isMenuView = true"></van-image>
          </div>
          <div style="width: 50%;text-align: right">
            <van-image :src="require('assets/imgs/icon_black.png')" @click="scanPop" style="margin-right: 5px" ></van-image>
          </div>
        </div>
        <div class="user-box">
          <div class="user-area">
            <div class="head-img" ></div>
            <div class="user-content-login" v-if="user && user.pname">
              <div class="user-name">{{ user.pname }}</div>
              <div class="user-device">{{i18n.deviceNo}} : {{ deviceInfo? deviceInfo.pSn : i18n.Unbound}}</div>
              <div class="user-device">{{i18n.DeviceState}} :
                <span class="user-device-unbound">{{ deviceInfo? i18n.Bind :i18n.Unbound}}</span>
              </div>
            </div>
            <div class="user-content-unLogin" v-else @click="toLogin">{{i18n.Login_Register}}</div>
          </div>
          <div class="add-devices" v-if="deviceItems.length < 2" @click="addEquipment">+ {{i18n.add_Devices}}</div>
          <div class="add-devices" v-else @click="deviceManagement">
            <van-image class="switch-img" :src="require('assets/imgs/switch.png')" width="19px" height="19px"></van-image>
            <label>{{i18n.switching_Devices}}</label>
          </div>
        </div>
      </div>

      <div class="how-about" :style="orderList.length > 0 ? 'display: none':''" style="height: 280px;">
        <div class="how-use">{{i18n.how_to_use_bajiewifi}}</div>
        <div class="row">
          <div class="num">1</div>
          <div class="desc">{{i18n.online_offline}}</div>
        </div>
        <div class="row">
          <div class="num">2</div>
          <div class="desc">{{i18n.scan_device_code}}</div>
        </div>
        <div class="row">
          <div class="num">3</div>
          <div class="desc">{{i18n.pay_for_the_order}}</div>
        </div>
        <div class="row">
          <div class="num">4</div>
          <div class="desc">{{i18n.behind_the_device}}</div>
        </div>
        <div class="row">
          <div class="num">5</div>
          <div class="desc">{{i18n.num5}}</div>
        </div>
        <div class="row">
          <div class="num">6</div>
          <div class="desc">{{i18n.num6}}</div>
        </div>
      </div>
      <van-swipe  :autoplay="3000" indicator-color="#036EB8">
        <van-swipe-item v-for="(item, i) in orderList"
                        :key="i">
          <div class="how-about" style="height: 250px;">
            <div class="refueling">
              <div class="country">
                {{item.country}}
              </div>
              <div class="pack" @click="refuelingPack(item)">
                {{i18n.refueling_pack}}
              </div>
            </div>
            <div class="total-refueling">{{item.text}}</div>
            <div class="use-progress">
              <Progress :progress="item.packageUsage/item.packageUsageTotal" :strokeWidth="13" :showInfo="true" />
            </div>
            <div class="refueling-use">
              <div class="used">{{item.packageUsage? item.packageUsage: '--'}}MB {{i18n.used}}</div>
              <div class="Remaining">{{i18n.remaining}} {{item.packageUsageBalance? item.packageUsageBalance: '--'}}MB/{{item.total?item.total:'--'}}</div>
            </div>
            <div class="use-time">
              <div class="item1">{{i18n.start_time}}</div>
              <div class="item2">{{item.reserverStartTime}}</div>
            </div>
            <div class="use-time">
              <div class="item1">{{i18n.end_time}}</div>
              <div class="item2">{{item.reserverEndTime}}</div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="traffic">
        <div class="content" @click="checkPOP">{{i18n.purchase_of_traffic}}</div>
        <van-image class="right-img" :src="require('assets/imgs/icon_more_green.png')" width="22px" height="22px"></van-image>
      </div>

      <div class="menu">
        <div class="list">
          <div class="item" @click="PurchasedPackages">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/cart.png')" width="30px" height="30px"></van-image>
            </div>
            <div class="desc">{{i18n.purchased_packages}}</div>
          </div>
          <div class="item" @click="addEquipment">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/add-device.png')" width="30px" height="30px"></van-image>
            </div>
            <div class="desc">{{i18n.add_equipment}}</div>
          </div>
          <div class="item" @click="deviceManagement">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/device-mgr.png')" width="30px" height="30px"></van-image>
            </div>
            <div class="desc">{{i18n.device_management}}</div>
          </div>
          <div class="item" @click="faq" style="display: none">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/faq.png')" width="30px" height="30px"></van-image>
            </div>
            <div class="desc">{{i18n.faq}}</div>
          </div>
        </div>
        <div class="list ext" style="display: none">
          <div class="item">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/suggestion.png')" width="30px" height="30px"></van-image>
            </div>
            <div class="desc">{{i18n.complaint_suggestions}}</div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="google-map">-->
<!--      <van-image :src="require('assets/imgs/icon_More@2x.png')" width="1.5rem" @click="isMenuView = true"></van-image>-->
<!--    </div>-->
    <popup-warp v-model="isMenuView" dialogTransition="slide-left" style="background: #fff;height: 100vh;">
      <menu-side></menu-side>
    </popup-warp>

    <van-dialog v-model="show" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
      <van-icon name="cross" class="cross-btn" @click="show = false" />
      <div class="package-title">
        {{i18n.data_has_been_used_up}}
      </div>
      <div style="max-height: 40vh;overflow: auto;">
        <div v-for="item in packageDtlList" class="pakage-box flex-s" :class="packageClass(item)" @click="selectPack(item)" :key="item.skuId">
          <div class="pakage-text">{{ item.text }}</div>
          <div class="pakage-price">{{ item.price }}</div>
        </div>
      </div>
      <div class="tip">
        {{i18n.original_traffic}}
      </div>
      <div style="text-align: center">
        <van-button @click="buyNow" class="bottom-pakage-btn">{{ i18n.Buy1 }}</van-button>
      </div>
    </van-dialog>
  </div>
   <div class="fixed" v-if="isPickUpShow" @click="isPickUpShow = false">
     <ScanQr @scanQr="onScanQr" />
   </div>
   <van-dialog v-model="methodShow" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
     <van-icon name="cross" class="cross-btn" @click="methodShow = false" />
     <div class="package-title-view">
       {{i18n.Scan_QR_code}}
     </div>
     <div class="method-box">
       <van-image :src="require('assets/imgs/mifi-back.png')" width="105px"></van-image>
       <van-image :src="require('assets/imgs/mifi_back02.png')" class="method-img-r" ></van-image>
       <div class="method-label">{{i18n.ScanDevice}}</div>
     </div>
     <div style="text-align: center;padding: 10px">
       <button class="confirm-dial-btn" @click="goWifimall">{{i18n.Confirm}}</button>
     </div>
   </van-dialog>
   <van-dialog v-model="methodScanShow" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
     <van-icon name="cross" class="cross-btn" @click="methodScanShow = false" />
     <div class="package-title-view">
       {{i18n.Scan_QR_code}}
     </div>
     <div class="method-box">
       <van-image :src="require('assets/imgs/mifi-back.png')" width="105px"></van-image>
       <van-image :src="require('assets/imgs/mifi_back02.png')" class="method-img-r" ></van-image>
       <div class="method-label">{{i18n.ScanDevice}}</div>
     </div>
     <div style="text-align: center;padding: 10px">
       <button class="confirm-dial-btn" @click="toScan">{{i18n.Confirm}}</button>
     </div>
   </van-dialog>

   <div style="position: fixed;right: 20px;bottom: 15%;">
     <a href="whatsapp://send?phone=+15360129730">
       <img src="../../assets/imgs/contactus/icon_whatsapp.png" alt="" height="40px" width="40px">
     </a>
   </div>

 </div>
</template>
<script>
import { mapState } from 'vuex'
import { PopupWarp } from '@/components/popup'
import { MenuSide } from '@/components/menu'
import Progress from '@/components/result/Progress'
import { MIFI_DEVICE, MIFI_PAY_LIST, MIFI_QR_CODE } from '@/apis/cabinet'
import ScanQr from 'views/scanQr/scanQr.vue'
import { USER_INFO } from '@/apis/user'
import dayjs from 'dayjs'
export default {
  components: {
    ScanQr,
    MenuSide,
    PopupWarp,
    Progress
  },
  data () {
    return {
      list: [],
      item: null,
      show: false,
      methodShow: false,
      methodScanShow: false,
      isMenuView: false,
      ishomeSearch: false,
      searchText: '',
      percent: 80,
      packageObj: {
        skuId: 0
      },
      packageDtlList: [],
      deviceInfo: null,
      deviceItems: [],
      isPickUpShow: false,
      orderList: [],
      typeMap: {},
      startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      endTime: '',
      packageCount: 1,
      packageName: ''
    }
  },
  computed: {
    ...mapState(['user', 'token', 'browser', 'qrcode']),
    i18n () {
      return this.$t('home')
    },
    // i18nHome () {
    //   return this.$t('home')
    // },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nActivation() {
      return this.$t('activation')
    }
  },
  watch: {
    latLng () {
      this.lazyLoad(this)
    }
  },
  methods: {
    toLogin() {
      this.$router.push('/otherLogin')
    },
    deviceManagement() {
      this.$router.push('/deviceManager')
    },
    PurchasedPackages() {
      if (this.deviceInfo != null) {
        this.$router.push('/PurchasedPackages?deviceSn=' + this.deviceInfo.pSn)
      } else {
        this.$router.push('/PurchasedPackages?deviceSn')
      }
    },
    addEquipment() {
      this.$router.push('/activityDevice')
    },
    packageClass (item) {
      return item.skuId === this.packageObj.skuId ? 'h-pakage' : ''
    },
    selectPack (item) {
      this.packageObj = item
      this.mifiPackage = item
      this.packageCount = item.Day
      this.packageName = item.text
      this.endTime = dayjs(this.startTime).add(item.Day, 'day').format('YYYY-MM-DD HH:mm:ss')
    },
    buyNow() {
      let order = this.packageObj
      order.startTime = this.startTime
      order.endTime = this.endTime
      order.productSendSn = this.deviceSn
      //  order.xugou = false
      let totalAmount = this.packageObj.price
      this.$store.commit("mifiOrder", order)
      this.$router.push({
        path: "/confirm",
        query: { price: totalAmount, payType: "mifi", currency: this.packageObj.currency, 'mifisn': this.deviceSn }
      })
    },
    faq() {
      this.$router.push('/packageOrder')
    },
    deviceList() {
      this.$post(
        MIFI_DEVICE, {}, (resp) => {
          this.deviceItems = resp.list
          var mifiDevices = []
          if (this.deviceItems.length > 0) {
            this.deviceInfo = this.deviceItems[0]
            this.deviceSn = this.deviceInfo.pSn
            for (let i = 0; i < this.deviceItems.length; i++) {
               mifiDevices.push(this.deviceItems[i].pSn)
              if (this.deviceItems[i].pdefault === 1) {
                this.deviceSn = this.deviceItems[i].pSn
                this.deviceInfo = this.deviceItems[i]
              }
            }
            this.$store.commit('mifisn', this.deviceSn)
            this.getOrderList()
          }
          this.$store.commit('mifiDevices', mifiDevices)
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    goWifimall () {
      this.methodShow = false
      if (this.deviceItems.length > 0) {
        if (this.deviceSn) {
          this.$router.push('/wifiMall?type=GM&deviceSn=' + this.deviceInfo.pSn)
        } else {
          this.$router.push('/wifiMall?type=GM')
        }
      } else {
        this.scanQr()
      }
    },
    checkPOP() {
      if (this.deviceItems.length > 0) {
        this.goWifimall()
      } else {
        this.methodShow = true
      }
    },
    scanPop() {
      this.methodScanShow = true
    },
    toScan() {
      this.methodScanShow = false
      this.scanQr()
    },
    refuelingPack(item) {
      this.initPackage(item);
      this.show = true
    },
    scanQr() {
     // this.deviceSn = 'srq311370m5wyrwm'
     // this.$store.commit('mifisn', this.deviceSn)
     // this.$router.push('/wifiMall?type=GM&deviceSn=' + this.deviceSn)
     this.isPickUpShow = true
    },
    onScanQr(qr) {
      this.isPickUpShow = false
      if (qr.includes("1713928951")) {
        qr = "https://wifi.chargenow.top/mifi2/#/?qr=1713928951"
      }
      if (qr.includes("1713928925")) {
        qr = "https://wifi.chargenow.top/mifi2/#/?qr=1713928925"
      }

      this.onScan(qr)
    },
    onScan(urlcode) {
      this.$post(MIFI_QR_CODE,
        {
          url: encodeURIComponent(urlcode)
        },
        resp => {
          this.deviceSn = resp.data
          this.$store.commit('mifisn', this.deviceSn)
          this.$router.push('/wifiMall?type=GM&deviceSn=' + this.deviceSn)
        }
      )
    },
    loadUser () {
      this.$get(
        USER_INFO,
        {},
        res => {
          if (res.user) {
            this.$store.commit('user', res.user)
           // this.$toast(this.i18n.msg_success_login)
          }
        },
        err => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit('token', null)
          })
        }
      )
    },
    getOrderList () {
      this.$post('/chargenow/mifi/orderList', {
          current: 1,
          size: 20,
          payStatus: 1,
          // orderStatus: 5,
          sn: this.deviceSn
        }, res => {
          this.$loading(false)
          let data = res.data.records
          data = data ? data.map(item => {
            item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
            if (item.packageName.split('-')[2].includes('Days')) {
              item.text = `${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}${this.i18n.天}`
              item.isPackage = 1
              item.total = `${item.packageName.split('-')[1]}`
            } else if (item.packageName.split('-')[2].includes('Unlimited')) {
              item.text = `${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
              item.isPackage = 0
              item.total = `${this.i18n.无限流量}`
            } else {
              item.text = `${item.packageName.split('-')[2]}MB/${this.i18n.天}`
              item.isPackage = 0
              item.total = `${item.packageName.split('-')[2]}`
            }
            item.packageStatusTitle = this.typeMap[item.packageStatus]
            return item
          }) : []
          for (var i = 0; i < data.length; i++) {
            if (data[i].packageStatus < 3) {
              this.orderList.push(data[i])
            }
          }
          // this.orderList.push(...data)
          // this.orderList = data
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    initPackage(item) {
      var skuId = item.skuId
      var country = item.country
      this.$post('chargenow/mifi/query', {
        'requestMethod': 'post',
        'url': '/mifi-open-api/wifiBase/packageDtlListBySkuId',
        'data': {
          'skuId': skuId,
          'country': country
        }
      }, (res) => {
        this.packageDtlList = JSON.parse(res.data)
        console.log(this.packageDtlList)
        this.packageDtlList = this.packageDtlList.map(item => {
          item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
          if (item.packageName.split('-')[2].includes('Days')) {
            item.text = `${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}天`
            item.isPackage = 1
          } else if (item.packageName.split('-')[2].includes('Unlimited')) {
            item.text = `${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
            item.isPackage = 0
          } else {
            item.text = `${item.packageName.split('-')[2]}MB/${this.i18n.天}`
            item.isPackage = 0
          }
          console.log(item)
          return item
        })
        this.packageObj = { ...this.packageDtlList[0] }
        this.mifiPackage = this.packageObj
        this.packageName = this.packageObj.text
        this.endTime = dayjs(this.startTime).add(this.packageObj.Day, 'day').format('YYYY-MM-DD HH:mm:ss')
        console.log('流量套餐列表===', this.packageDtlList)
      }, error => {
        console.log(error)
      }, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
    }
  },
  created () {
    if (this.token) {
      this.loadUser()
    }
    if (this.user) {
      this.deviceList()
    }
    this.typeMap = {
      0: this.i18n.type_0,
      1: this.i18n.type_1,
      2: this.i18n.type_2,
      3: this.i18n.type_3,
      4: this.i18n.type_4,
      9: this.i18n.type_9,
      33: this.i18n.type_33,
      88: this.i18n.type_88
    }
    var qr = this.$route.query.qr
    if (qr) {
      var path = window.location.href;
      this.onScan(path)
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.home{
  position: relative;
  display: flex;
  .home-left{
    position: fixed;
    top: 96px;
    left: 40px;
    z-index: 1;
  }
}
.google-map{
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  overflow: hidden;
}
.content{
  width: 100%;
}
.user-info{
  width: 100%;
  border-radius: 15px;
  .head-img{
    width: 147px;
    height: 147px;
    background: #E9E9E9;
    border-radius: 50%;
    margin: 40px;
  }
  .user-box{
    background-image: url("../../assets/imgs/img_dollar-ext.png");
    background-size: cover;
    background-position: center;
  }
  .user-area{
    display: flex;
  }
  .backgroud-img{
    position: fixed;
    top: 0;
    z-index: -1;
  }
  .user-content-unLogin{
    font-family: MyFont1;
    font-size: 36px;
    color: #FFFFFF;
    font-weight: Bold;
    //align-content: center;
    margin-top: 85px;
  }
  .user-content-login{
    color: #FFFFFF;
    //align-content: center;
    margin-top: 25px;
    font-family: MyFont2;
  }
  .user-name{
    font-size: 36px;
    padding-bottom: 20px;
    font-weight: bold;
  }
  .user-device{
    font-size: 24px;
    padding-bottom: 20px;
  }
  .user-device-unbound{
    font-family: MyFont2;
    font-weight: 400;
    font-size: 16px;
    color: #036EB8;
    background: #ffffff;
    padding: 5px 10px 5px 10px;
    border-radius: 16px;
  }
  .add-devices{
    font-family: MyFont2;
    font-weight: 400;
    font-size: 28px;
    color: #FFFFFF;
    text-align: right;
    padding-bottom: 10px;
    padding-right: 30px;
    label{
      padding-left: 10px;
    }
  }
  .switch-img{
    vertical-align: -5px;
    display: inline-block;
  }
}
.cross-btn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 40px;
}
.method-img-r{
  position: absolute;
  margin-left: 85px;
  width: 244px;
}
.method-box{
  padding: 20px 20px 40px 20px;
  .method-label{
    font-family: MyFont2;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    width: 4.2rem;
    margin-left: 3.5rem;
    margin-top: -1.3rem;
  }
}
.confirm-dial-btn{
  height: 80px;
  width: 250px;
  background: #FFFFFF;
  border-radius: 40px 40px 40px 40px;
  border: 2px solid #036EB8;
  color: #036EB8;
}
.how-about{
  background: #FFFFFF;
  box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.08);
  border-radius: 18px 18px 18px 18px;
  margin: 20px;
  .how-use{
    font-family: MyFont1;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    text-align: center;
    padding: 20px;
  }
  .row{
    display: flex;
    padding: 12px;
  }
  .num{
    width: 32px;
    height: 32px;
    background: #1EBE86;
    border-radius: 50%;
    text-align: center;
    font-family: MyFont2;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
  }
  .desc{
    padding-left: 12px ;
    font-family: MyFont2;
    font-weight: bold;
    font-size: 22px;
    color: #333333;
    width: 90%;
  }
  .use-progress {
    padding: 10px;
  }
  .refueling{
    display: flex;
  }
  .refueling-use{
    display: flex;
    padding: 20px;
    font-family: MyFont2;
    font-weight: bold;
    font-size: 22px;
    color: #333333;
    .Remaining{
      text-align: right;
      width: 60%;
    }
    .used{
      width: 40%;
    }
  }
  .total-refueling{
    font-family: MyFont2;
    font-weight: normal;
    font-size: 32px;
    color: #333333;
    padding: 30px 0 22px 20px;
    font-weight: bold;
  }
  .country{
    width: 50%;
    min-height: 58px;
    max-height: 88px;
    background: #1EBE86;
    border-radius: 18px 0px 18px 0px;
    color: #ffffff;
    font-size: 30px;
    font-family: MyFont2;
    text-align: center;
    align-content: center;
    font-weight: bold;
  }
  .pack{
    font-family: MyFont3;
    font-weight: bold;
    font-size: 24px;
    color: #1EBE86;
    font-weight: bold;
    text-align: right;
    width: 50%;
    padding: 15px 20px 0 0;
  }
  .use-time{
    display: flex;
    font-family: MyFont2;
    font-weight: 400;
    font-size: 22px;
    color: #666666;
    padding: 20px;
  }
  .item1{
    width: 30%;
  }
  .item2{
    width: 70%;
    text-align: right;
  }
}
.traffic{
  margin: 20px;
  background-image: url("../../assets/imgs/traffic-bkg.png");
  background-size: cover;
  background-position: center;
  height: 84px;
  display: flex;
  .content{
    font-family: MyFont1;
    font-weight: 600;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    height: 100%;
    margin-top: 25px;
    padding-left: 20px;
  }
  .right-img{
    margin-top: 25px;
  }
}
.menu{
  background: #FFFFFF;
  box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.08);
  border-radius: 18px 18px 18px 18px;
  margin: 20px;
  .item{
    width: 33%;
    text-align: center;
    padding: 30px 0 0 0;
  }
  .list{
    display: flex;
  }
  .desc{
    font-family: MyFont2;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
  }
  .ext{
    padding-bottom: 30px;
  }
}
.cross-btn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 40px;
}
.flex-s{
  display: flex;
  justify-content: space-between;
  align-items: center
}
.package-title{
  text-align: center;
  padding: 104px 40px 66px 40px;
  font-family: MyFont3;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
}
.package-title-view{
  text-align: center;
  padding: 30px 40px 30px 40px;
  font-family: MyFont2;
  color: #333333;
  font-family: MyFont2;
  font-weight: bold;
  font-size: 36px;
}
.tip{
  font-family: MyFont4;
  font-weight: 300;
  font-size: 22px;
  color: #666666;
  text-align: center;
  padding: 20px;
}
.pakage-box {
  margin: 20px;
  position: relative;
  // width: 100%;
  background: #FFFFFF;
  border-radius: 18px 18px 18px 18px;
  border: 1px solid #D1D1D1;
  padding: 17px 20px;
  .pakage-text{
    width: 70%;
    font-family: MyFont2;
    font-weight: bold;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
  }
  .pakage-price {
    font-family: MyFont3;
    font-size: 30px;
    font-weight: bold;
    color: #FF1919;
  }
}
.bottom-pakage-btn{
  font-weight: 400;
  font-size: 24px;
  color: #1EBE86;
  width: 280px;
  height: 76px;
  border-radius: 40px 40px 40px 40px;
  margin: 30px;
  border: 2px solid #1EBE86;
}
.h-pakage {
  border: 3px solid #00AB46;
}
.fixed{
  position: fixed;
  bottom: 0;
  width: 100%;
  // background: rgba(45, 45, 45, 0.5);
  height: 100%;
}
</style>>
